module.exports = __webpack_public_path__ + "static/img/total_en.a9851765.png";